export const getAppUserModel = (stack: StackDto, account: Account): 'num' | 'numa' | 'ca' => {
    if (!account.optional_features?.sync_stacker_users) {
        return 'ca'
    } else if (stack.options?.sync_users_as_auths) {
        return 'numa'
    }
    return 'num'
}
